import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./styles.css";
import vendorAuthService from "@/service/auth.service/vendor.auth.service"; // Assuming you have vendorAuthService

function VendorForgetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Email validation function using a regex pattern
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Handle email input change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError(""); // Clear previous errors
  };

  // Step 1: Submit email to get OTP
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset any previous error
    setSuccessMessage(""); // Reset success message

    const trimmedEmail = email.trim().toLowerCase();

    if (!trimmedEmail) {
      setError("Email is required.");
      return;
    }

    if (!validateEmail(trimmedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const response = await vendorAuthService.sendForgetPasswordOtp(trimmedEmail);
      setLoading(false); 
      if (response.status === true) {
        setSuccessMessage("OTP sent successfully to your email.");
        navigate("/vendor/auth/verify-password-reset-otp", {
          state: { email: trimmedEmail },
        });
      } else {
        setError("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      const message  =  error?.response?.data?.data?.error || error?.response?.data?.message || "Failed to send OTP!";
      setError(message);
      setLoading(false); // Stop loading if an error occurs
    }
  };

  return (
    <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: "#f5f5f5",
          p: isMobile ? 4 : isTablet ? 6 : 0,
          height: isMobile ? "70vh" : "100vh",
        }}
      >
        <Paper className="inner-card" elevation={5}>
          <Typography variant="h5" color="#5E5ACF" fontWeight="bold">
            Forget Password?
          </Typography>
          <Typography className="textField" paragraph>
            Please enter your email to receive a verification code.
          </Typography>
          <form onSubmit={handleEmailSubmit}>
            <TextField
              fullWidth
              margin="normal"
              label="Email Address"
              variant="outlined"
              value={email}
              onChange={handleEmailChange}
              error={!!error}
              helperText={error}
            />
            {successMessage && (
              <Typography color="green" variant="body2">
                {successMessage}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              className="btn-submit"
              sx={{
                mt: 2,
                color: "black",
                fontWeight: "bold",
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} /> // Circular loader
              ) : (
                "Send OTP"
              )}
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
  );
}

export default VendorForgetPassword;
